import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class stripComingSoon {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)

    const swiper = new Swiper(this.strip.find('.swiper')[0], {
      direction: 'horizontal',
      effect: 'slide',
      slidesPerView: 'auto',
      centeredSlides: false,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 1,
          spaceBetween: 40,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    })
  }
}

export default stripComingSoon
